import PageImageView from '../../../views/page-image'

const Maks2PageImageView = PageImageView.extend({
    render() {
        this.el.src = 'data/' + this.model.get('slug') + '/screens/' + this.model.get('image_prefix') + '/item' + this.model.get('index') + '.webp';

        (this.model.get('custom_widths') || []).forEach(custom_width => {
            if (custom_width.image_index === this.model.get('index')) {
                this.el.style.width = custom_width.custom + "%"
                if (custom_width.left) {
                    this.el.style.paddingRight = "0.5%"
                } else {
                    this.el.style.paddingLeft = "0.5%"
                }
            }
        })

        this.$el.on('load', () => this.$el.addClass('visible'))

        return this
    }
})

export default Maks2PageImageView

